import { useMutation } from "@apollo/client/react";
import { DSCircularButton } from "@components/design-system/molecules";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import ExportModal from "./ExportModal";
import MARK_NOTES_EXPORTED from "../../graphql/mutations/MarkNotesExported";
import SEND_EXPORT_NOTE_EMAIL from "../../graphql/mutations/SendExportNoteEmail";
import { alert } from "../common/Alert";

function ExistingNoteEmailExportButton({ note, refetch }) {
  const [shouldShowModal, setShouldShowModal] = useState(false);
  const location = useLocation();

  const methods = useForm();
  const { control, handleSubmit } = methods;

  const [sendExportNoteEmail] = useMutation(SEND_EXPORT_NOTE_EMAIL);
  const [modifyNotes] = useMutation(MARK_NOTES_EXPORTED);

  function hideModal() {
    setShouldShowModal(false);
  }

  const onSend = async (data) => {
    sendExportNoteEmail({
      variables: {
        toEmail: data?.toEmail,
        grantedNoteUuid: note?.uuid,
        isForAssistant: false,
        specialInstructions: data?.specialInstructions,
        areAttachmentsIncluded: data?.includeAttachments,
        shouldEmbedEmailExports: data?.exportType === "embeddedText",
      },
    })
      .then(async () => {
        setShouldShowModal(false);
        modifyNotes({
          variables: {
            noteUuids: [note.uuid],
            action: "mark_exported",
          },
        }).then(() => {
          alert(
            "info",
            `Email sent! ${
              note?.hasBeenExported
                ? ""
                : "Your note has now been marked as exported."
            }`,
          );
        });
        if (location.pathname == "/inbox") {
          refetch({});
        } else {
          if (refetch) {
            refetch({ isApproved: true });
          }
        }
      })
      .catch(() => {
        alert("error", "An error occurred. Please try again later.");
      });
  };

  if (note) {
    const isDisabled =
      note?.isNewRecording ||
      note?.isMarkedAsProcessing ||
      note?.isMarkedAsFailed;

    return (
      <>
        <ExportModal
          shouldShowModal={shouldShowModal}
          hideModal={hideModal}
          handleSubmit={handleSubmit}
          onSend={onSend}
          control={control}
          methods={methods}
        />
        <DSCircularButton
          title="Export note via email"
          icon={faEnvelope}
          size="sm"
          variant="primary"
          disabled={isDisabled}
          onClick={() => {
            if (!note?.isDraft && !note?.isNewRecording) {
              setShouldShowModal(true);
            }
          }}
          dataTestId="email-export-note-button"
        />
      </>
    );
  } else return null;
}

export default ExistingNoteEmailExportButton;
